<div *ngIf="cargando" class="flex justify-center items-center min-h-screen">
  <div class="flex flex-col items-center">
    <div class="spinner-border animate-spin inline-block w-12 h-12 border-4 border-t-transparent border-azul rounded-full" role="status"></div>
    <p class="mt-4 text-lg text-azul">{{'cargando-perfil' | translate}}</p>
  </div>
</div>
<div *ngIf="!cargando" class="grid grid-cols-2 gap-6 p-6 max-w-3xl mx-auto">
    <div class="flex items-center justify-center col-span-1 animate-fade-right">
      <img src="{{cuerpoTecnico.avatar}}" alt="{{cuerpoTecnico.nombre}}" class="w-auto h-auto object-cover [mask-image:linear-gradient(to_bottom,black_90%,transparent_100%)]"/>
    </div>
    <!-- Informacion Cuerpo Tecnico -->
    <div class="flex flex-col justify-center space-y-2 col-span-1">
      <span class="text-xl sm:text-4xl lg:text-6xl font-extrabold text-yellow-600 animate-jump-in">{{cuerpoTecnico.tipo.toUpperCase()}}</span>
      <h1 class="text-lg sm:text-2xl font-bold text-azul animate-jump-in animate-delay-300">{{cuerpoTecnico.nombre}}</h1>
      <span class="text-black animate-jump-in animate-delay-700">{{'edad' | translate}} {{cuerpoTecnico.edad}}</span>
    </div>
</div>
  
